<template>
  <div class="card" v-show="currentCardId == cardId">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>{{ title }}</h2>
        <p>{{ lead }}</p>
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <div class="card-content">
            <div class="edit-form-item">
              <div class="item-body">
                <el-input
                  type="textarea"
                  v-model="fieldValue"
                  :autosize="autosize"
                  :title="inputTitle"
                />
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'

type ShokurekishoTextareaField = 'skills' | 'intelligence' | 'otherskills'

type Autosize = boolean | { minRows?: number; maxRows?: number }

const props = withDefaults(
  defineProps<{
    currentCardId?: string
    cardId: string
    title: string
    lead: string
    field: ShokurekishoTextareaField
    autosize?: Autosize
    inputTitle?: string
  }>(),
  {
    autosize: () => ({ minRows: 3, maxRows: 5 }),
    inputTitle: ''
  }
)

const formatData = useShokurekishoFormatData()

const fieldValue = computed({
  get() {
    const value = formatData[props.field]
    return typeof value === 'string' ? value : ''
  },
  set(next: string) {
    formatData[props.field] = next
  }
})
</script>
